module.exports = __webpack_public_path__ + "img/JH.fdf4ffc4.png";